/**
 * Background Sync API
 * Triggers and monitors background data syncs for integrations.
 */
import api from './index'

export interface SyncStatus {
  dynamics365: {
    configured: boolean
    connected: boolean
  }
  google_analytics: {
    configured: boolean
    connected: boolean
  }
  microsoft365: {
    configured: boolean
    connected: boolean
  }
}

export interface TriggerSyncResponse {
  success: boolean
  message: string
  syncs_started: string[]
}

/**
 * Trigger all configured background syncs.
 * Called on login to refresh data asynchronously.
 */
export async function triggerBackgroundSyncs(): Promise<TriggerSyncResponse> {
  const response = await api.post<TriggerSyncResponse>('/sync/trigger-all')
  return response.data
}

/**
 * Get sync status for all integrations.
 */
export async function getSyncStatus(): Promise<SyncStatus> {
  const response = await api.get<{ data: SyncStatus }>('/sync/status')
  return response.data.data
}

/**
 * Trigger Dynamics 365 sync manually.
 */
export async function triggerDynamicsSync(): Promise<{ success: boolean; message: string }> {
  const response = await api.post<{ success: boolean; message: string }>('/sync/dynamics')
  return response.data
}

/**
 * Trigger Google Analytics refresh manually.
 */
export async function triggerAnalyticsSync(): Promise<{ success: boolean; message: string }> {
  const response = await api.post<{ success: boolean; message: string }>('/sync/analytics')
  return response.data
}

/**
 * Trigger Microsoft 365 sync manually.
 */
export async function triggerMicrosoftSync(): Promise<{ success: boolean; message: string }> {
  const response = await api.post<{ success: boolean; message: string }>('/sync/microsoft')
  return response.data
}

export const backgroundSyncApi = {
  triggerBackgroundSyncs,
  getSyncStatus,
  triggerDynamicsSync,
  triggerAnalyticsSync,
  triggerMicrosoftSync,
}

export default backgroundSyncApi
